import { render, staticRenderFns } from "./AlertLayout.vue?vue&type=template&id=78b3a71b"
import script from "./AlertLayout.vue?vue&type=script&lang=js"
export * from "./AlertLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports